import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { map, Observable } from 'rxjs';
import { INTERCONEXION_GATEWAY, INTERCONEXION_ICOIJ, INTERCONEXION_METHOD_DEMANDASBYFILTER, INTERCONEXION_METHOD_GETACUSEDEMANDA, INTERCONEXION_METHOD_GETACUSEPROMOCION, INTERCONEXION_METHOD_PROMOTIONSBYFILTER, INTERCONEXION_PROMOTIONS } from '../../app-module.token';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseReponseGeneric } from '../../commons/class/BaseReponseGeneric.interface';
import { Documents } from '../../commons/class/archivo.inteface';

export interface PromotionsByFilterDto {
    idFolioRespuesta: number;
    fechaRecepcion: string;
    origen: string;
    organo: string;
    numExpediente: string;
    tipoAsunto: string;
}

@Injectable({ providedIn: 'root' })
export class reimpresionAcusesService {

    private gateway = inject(INTERCONEXION_GATEWAY);
    private icoij = inject(INTERCONEXION_ICOIJ);
    private promotions = inject(INTERCONEXION_PROMOTIONS);
    private methodPromotionsByFilter = inject(INTERCONEXION_METHOD_PROMOTIONSBYFILTER);
    private methodDemandasByFilter = inject(INTERCONEXION_METHOD_DEMANDASBYFILTER);
    private methodGetAcuseDemanda = inject(INTERCONEXION_METHOD_GETACUSEDEMANDA);
    private methodGetAcusePromocion = inject(INTERCONEXION_METHOD_GETACUSEPROMOCION);
    private httpS: HttpService = inject(HttpService);

    /**
     * Obtiene las promociones por filtro, se construye la ruta para la consulta utilizando la URL raíz, el segmento correspondiente y la función de consulta, se agregan los parámetros de fecha de inicio, fecha de fin, ID de órgano y folio a la ruta como una cadena de consulta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta como un Observable con un objeto genérico que contiene un array de promociones que cumplen con los filtros especificados
     * @param fechaInicio 
     * @param fechaFin 
     * @param iOIJ 
     * @param folio 
     * @returns 
     */
    getPromotionsByFilter(fechaInicio: string, fechaFin: string, iOIJ: string, folio: string): Observable<BaseReponseGeneric<PromotionsByFilterDto[]>> {
        const params = new HttpParams()
            .set('fechaInicio', fechaInicio)
            .set('fechaFin', fechaFin)
            .set('iOIJ', iOIJ)
            .set('folio', folio ?? '');

        const header = new HttpHeaders();
        const ruta = `${this.gateway}${this.icoij}${this.methodPromotionsByFilter}?${params.toString()}`;//'oaj.icoij.gateway/icoij/Notificaciones';
        return this.httpS.getRequest(ruta, header) as Observable<BaseReponseGeneric<PromotionsByFilterDto[]>>;
    }

    /**
     * Obtiene las demandas por filtro, se construye la ruta para la consulta utilizando la URL raíz, el segmento correspondiente y la función de consulta, se agregan los parámetros de fecha de inicio, fecha de fin, ID de órgano y folio a la ruta como una cadena de consulta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta como un Observable con un objeto genérico que contiene un array de demandas que cumplen con los filtros especificados
     * @param fechaInicio 
     * @param fechaFin 
     * @param iOIJ 
     * @param folio 
     * @returns 
     */
    getDemandasByFilter(fechaInicio: string, fechaFin: string, iOIJ: string, folio: string): Observable<BaseReponseGeneric<PromotionsByFilterDto[]>> {
        const params = new HttpParams()
            .set('fechaInicio', fechaInicio)
            .set('fechaFin', fechaFin)
            .set('iOIJ', iOIJ)
            .set('folio', folio ?? '');

        const header = new HttpHeaders();
        const ruta = `${this.gateway}${this.icoij}${this.methodDemandasByFilter}?${params.toString()}`;//'oaj.icoij.gateway/icoij/Notificaciones';
        return this.httpS.getRequest(ruta, header) as Observable<BaseReponseGeneric<PromotionsByFilterDto[]>>;
    }

    /**
     * Obtiene el acuse de una demanda, se construye la ruta para la consulta utilizando la URL raíz, el segmento correspondiente y la función de consulta, se agrega el ID de demanda a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
     * @param idDemanda 
     * @returns 
     */
    GetAcuseDemand(idDemanda: number) {
        const ruta = `${this.gateway}${this.icoij}${this.methodGetAcuseDemanda}/${idDemanda}`;
        return this.httpS.getRequest(ruta)
    }

    /**
     * Obtiene el acuse de una promoción, se construye la ruta para la consulta utilizando la URL raíz, el segmento correspondiente y la función de consulta, se agrega el ID de promoción a la ruta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta del servicio
     * @param idPromocion 
     * @returns 
     */
    getAcusePromocion(idPromocion: number) {
        const ruta = `${this.gateway}${this.icoij}${this.methodGetAcusePromocion}/${idPromocion}`;
        return this.httpS.getRequest(ruta)
    }


    /**
     * Obtiene los documentos por ID de transacción y tipo de documento, se construye la ruta para la consulta utilizando la URL raíz, el segmento correspondiente y la función de consulta, se agregan los parámetros de ID de transacción y tipo de documento a la ruta como una cadena de consulta, se hace una petición GET al servicio utilizando la ruta construida y se retorna la respuesta como un Observable con un array de documentos
     * @param idTransaccion 
     * @param tipoDocumento 
     * @returns 
     */
    getDocuments(idTransaccion: number, tipoDocumento: number
    ): Observable<Documents[]> {
        const url = `oaj.icoij.gateway/icoij/getDocumentosByIdTrans/${idTransaccion}/${tipoDocumento}`;
        return this.httpS.getRequest(url).pipe(
            map((resp: any) => {
                if (resp?.succcess) {
                    if (Array.isArray(resp.data)) {
                        return resp.data as Documents[];
                    }
                    if (resp.data?.$values && Array.isArray(resp.data.$values)) {
                        return resp.data.$values as Documents[];
                    }
                }
                return [] as Documents[];
            })
        ) as Observable<Documents[]>;
    }
}